import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../helper/URLHelper';

import MetaAgentRouteView from './pages/MetaAgentRouteView.vue';
import MetaAgentIndexPage from './pages/MetaAgentIndexPage.vue';
import MetaAgentEmptyState from './pages/EmptyState.vue';
import OverviewIndex from './overview/Index.vue';
import KnowledgeIndex from './knowledge/Index.vue';
import SkillsIndex from './skills/Index.vue';
import PlaygroundIndex from './playground/Index.vue';
import SettingsIndex from './settings/Index.vue';

const meta = {
  permissions: ['administrator'],
  featureFlag: FEATURE_FLAGS.META_BUSINESS_AGENT,
  installationTypes: [INSTALLATION_TYPES.CLOUD, INSTALLATION_TYPES.ENTERPRISE],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/meta-business-agent'),
    component: MetaAgentRouteView,
    children: [
      {
        path: '',
        redirect: to => ({
          name: 'meta_agent_index',
          params: {
            accountId: to.params.accountId,
            navigationPath: 'meta_agent_overview_index',
          },
        }),
      },
      {
        path: frontendURL('accounts/:accountId/meta-business-agent/connect'),
        component: MetaAgentEmptyState,
        name: 'meta_agent_connect_index',
        meta,
      },
      {
        path: frontendURL(
          'accounts/:accountId/meta-business-agent/:inboxId/overview'
        ),
        component: OverviewIndex,
        name: 'meta_agent_overview_index',
        meta,
      },
      {
        path: frontendURL(
          'accounts/:accountId/meta-business-agent/:inboxId/knowledge'
        ),
        component: KnowledgeIndex,
        name: 'meta_agent_knowledge_index',
        meta,
      },
      {
        path: frontendURL(
          'accounts/:accountId/meta-business-agent/:inboxId/skills'
        ),
        component: SkillsIndex,
        name: 'meta_agent_skills_index',
        meta,
      },
      {
        path: frontendURL(
          'accounts/:accountId/meta-business-agent/:inboxId/playground'
        ),
        component: PlaygroundIndex,
        name: 'meta_agent_playground_index',
        meta,
      },
      {
        path: frontendURL(
          'accounts/:accountId/meta-business-agent/:inboxId/settings'
        ),
        component: SettingsIndex,
        name: 'meta_agent_settings_index',
        meta,
      },
      // Resolver: the sidebar links here because it cannot know which inbox to
      // open; this page picks one and replaces the route.
      {
        path: frontendURL(
          'accounts/:accountId/meta-business-agent/:navigationPath'
        ),
        component: MetaAgentIndexPage,
        name: 'meta_agent_index',
        meta,
      },
    ],
  },
];

export default routes;
